import fetch from '@/utils/fetch';
// import {api_url} from "../popular/index"
const api_url = process.env.VUE_APP_API;

export const organization_info = () => fetch({//组织页顶部信息
  url: `${api_url}/organization`,
});

export const org_table = data => fetch({//分页查询组织信息
  url: `${api_url}/manager/organization`,
  method: 'post',
  data ,
});

export const org_data = data => fetch({//table详情组织信息
  url: `${api_url}/organization/companyInfo/${data.companyId}`,
});
export const org_tree = data => fetch({//组织架构
  url: `${api_url}/organization/frameworkTree/${data.companyId}`,
});
export const org_Info = data => fetch({//组织架构
  url: `${api_url}/organization/frameworkInfo/${data.companyId}`,
});